import { Controller } from "@hotwired/stimulus"

export default class StatsDateControlsController extends Controller {
  static targets = ["startDate", "endDate"]

  applyDates() {
    const startDate = this.startDateTarget.value
    const endDate = this.endDateTarget.value

    if (!startDate && !endDate) return

    const url = new URL(window.location.href)
    url.searchParams.delete("period")

    if (startDate) url.searchParams.set("start_date", startDate)
    else url.searchParams.delete("start_date")

    if (endDate) url.searchParams.set("end_date", endDate)
    else url.searchParams.delete("end_date")

    window.location.href = url.toString()
  }
}
